import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../../styles/Footer.css";

export default function Footer() {
  const { t } = useTranslation();

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="container footer-top">
        <section className="footer-card footer-brand-card">
          <h3>{t("footer.contactTitle")}</h3>
          <p>{t("footer.contactText")}</p>

          <div className="footer-info-list">
            <a
              href="https://maps.google.com/?q=Calle+Albercones+14+18170+Alfacar+Granada"
              target="_blank"
              rel="noreferrer"
            >
              <span>📍</span>
              {t("footer.address")}
            </a>

            <p>
              <span>🕒</span>
              {t("footer.openingHours")} · {t("footer.morningHours")} /{" "}
              {/* {t("footer.afternoonHours")} */}
            </p>

            <p>
              <span>☎️</span>
              +34 958 540 575
            </p>

            <p>
              <span>📞</span>
              +34 641 292 961
            </p>

            <p>
              <span>✉️</span>
              info@alfasol.es
            </p>
          </div>
        </section>

        <section className="footer-card">
          <h3>{t("footer.joinTitle")}</h3>
          <p>{t("footer.joinText")}</p>

          <div className="footer-info-list">
            <p>
              <span>☎️</span>
              +34 958 540 575
            </p>

            <p>
              <span>📞</span>
              +34 641 292 961
            </p>

            <p>
              <span>✉️</span>
              info@alfasol.es
            </p>
          </div>
        </section>

        <section className="footer-card">
          <h3>{t("footer.legalTitle")}</h3>

          <div className="footer-legal-links">
            <Link to="/legal-notice" onClick={handleScrollTop}>
              {t("footer.legalNotice")}
            </Link>
            <Link to="/privacy-policy" onClick={handleScrollTop}>
              {t("footer.privacyPolicy")}
            </Link>
            <Link to="/cookies-policy" onClick={handleScrollTop}>
              {t("footer.cookiesPolicy")}
            </Link>
            <Link to="/terms-of-sale" onClick={handleScrollTop}>
              {t("footer.termsOfSale")}
            </Link>
            <Link to="/shipping-policy" onClick={handleScrollTop}>
              {t("footer.shippingPolicy")}
            </Link>
            <Link to="/returns-policy" onClick={handleScrollTop}>
              {t("footer.returnsPolicy")}
            </Link>
          </div>
        </section>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Alfasol. {t("footer.rights")}
      </div>
    </footer>
  );
}